import { ajax, pageTo, removeMetaCache, toast } from '@platform/api';
import { generateColSettingConfig } from '../../adapter/utils';

export function getRawColumns(store, id){
    const config = generateColSettingConfig(store, id);
    return new Promise((resolve, reject) => {
        ajax({
            url: '/nccloud/platform/template/getUserTemplateMap.do',
            async: true,
            data: {
                appcode: config.appCode || pageTo.getAppCode(),
                pagecode: config.pageCode || pageTo.getPageCode(),
                templatecode: config.code,
                templateId: config.pageId,
                areatype: '2',
            },
            success: res => {
                resolve(res);
            },
            error: err => {
                console.error(err);
                toast({
                    content: err.message,
                    color: 'danger',
                });
                reject(err);
            },
        });
    });
}

export function setColumns(store, id, columns){
    const config = generateColSettingConfig(store, id);
    return new Promise((resolve, reject) => {
        ajax({
            url: '/nccloud/platform/template/propertySetting.do',
            data: {
                appcode: config.appCode || pageTo.getAppCode(),
                pagecode: config.pageCode || pageTo.getPageCode(),
                templatecode: config.code,
                templateId: config.pageId,
                [id]: {
                    areaId: config.areaId,
                    items: columns,
                },
            },
            success: res => {
                removeMetaCache(config.appCode, config.pageCode);
                resolve(res);
            },
            error: err => {
                console.error(err);
                toast({
                    content: err.message,
                    color: 'danger',
                });
                reject(err);
            },
        }); 
    });
}

export function resetWidths(store, id){
    const config = generateColSettingConfig(store, id);
    return new Promise((resolve, reject) => {
        ajax({
            url:'/nccloud/platform/template/resetwidth.do',
            data:{
                templateId: config.pageId,
                areaId: id,
            },
            success: res => {
                removeMetaCache(config.appCode, config.pageCode);
                resolve(res);
            
            },
            error : err => {
                console.error(err);
                toast({
                    content: err.message,
                    color: 'danger',
                });
                reject(err);
            },
        });
    });
}

export function resetColumns(store, id){
    const config = generateColSettingConfig(store, id);
    return new Promise((resolve, reject) => {
       
        ajax({
            url: '/nccloud/platform/template/removeUserPropertySettings.do',
            data: {
                templateId: config.pageId,
                areaId: config.areaCode || id,
            },
            success: res => {
                removeMetaCache(config.appCode, config.pageCode);
                resolve(res);
            },
            error: err => {
                console.error(err);
                toast({
                    content: err.message,
                    color: 'danger',
                });
                reject(err);
            },
        }); 
    });
}